module.exports = __webpack_public_path__ + "img/青木香.51faefeb.jpg";